import { PagingSearch } from "./common"

export class LinkUrl {
    buddyUrl: string
    expireDate: string
    redirectUrlValue: string
    regDate: string
    status: string
    urlDescription: string
    urlKey: string
    urlValue: string
    userNo: number
    title: string
    filePath: string
    productId: number
    urlType: string
    urlTypeName: string
    isUpdateMode: boolean = false
    userId: string
    userName: string
    isOpen: boolean = false
}
export class BuddyUrlSearch extends PagingSearch{
    searchType: string
    urlType: string
}
export class LinkHistory {
    buddyType: string
    buddyTypeName: string
    buddyUrl: string
    filePath: string
    historyNo: number
    logNo: number
    ipAddr: string
    orderId: string
    oasisTotalPayment: number
    oasisUsageCoupon: number
    oasisUsagePoint: number
    referer: string
    regDate: string
    sessionId: string
    title: string
    totalPayment: number
    totalPrice: number
    urlKey: string
    urlType: string
    urlTypeName: string
    urlValue: string
    userNo: number
    userId: string
    userName: string
    refererGroupCode: string
    refererGroupName: string
    eventCount: number
    oasisUserId: string
    oasisUserName: string
    oasisUserNo: number
}
export class LinkHistoryDetail {
    historyDetailNo: number
    historyNo: number
    price: number
    productId: number
    productTitle: string
    quantity: number
}

export class HistorySearch extends PagingSearch{
    status: string
    userNo: number
    urlType: string
    refererGroup: string
    buddyType: string
    searchType: string // id, userName, corpCode
    searchDateType: string 
    accountMonth: string
}

export class LinkStats {
    regDate: string
    buyEventCount: number
    cancelEventCount: number
    clickEventCount: number
    eventCount: number
    title: string
    totalBuyPayment: number
    totalBuyPrice: number
    totalCancelPayment: number
    totalCancelPrice: number
    totalPayment: number
    totalPrice: number
    unitCount: number
    urlKey: string
    urlType: string
    urlTypeName: string
    urlValue: string
    filePath: string
    buddyUrl: string
    commissionPercent: number
    commissionPrice: number
}

export class LinkStatsDetail {
    buddyType: string
    urlKey: string
    detailList: LinkStatsDetailList[]
}
export class LinkStatsDetailList {
    eventCount: number
    refererGroupCode: string
    refererGroupName: string
    totalPayment: number
    totalPrice: number
    unitCount: number
}